import nookies from 'nookies'

export function getCookie(key, context = {}) {
  return nookies.get(context)[key]
}

export function destroyCookie(key, options = {}, context = null) {
  return nookies.destroy(context, key, options)
}
